// extracted by mini-css-extract-plugin
export default {"svg":"ChartTradingButton_svg__jtCeX","div":"ChartTradingButton_div__r+Hdx"};